import React from 'react';
import './Footer.css'

const Footer = () => {
  return (
    <footer id="footer">
      <p>2024 Basic Memory Game. All Rights Reserved.</p>
    </footer>
  );
};

export default Footer;
